;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { ButtonIcon } from '@qogita/ui/v2/button-icon'
import { Icon } from '@qogita/ui/v2/icon'

export function NoActivePriceListsBanner({
  hasActivePriceLists,
}: {
  hasActivePriceLists: boolean
}) {
  if (hasActivePriceLists) {
    return null
  }

  return (
    <div className="bg-error-900 text-brand-inverted flex w-full items-center justify-center gap-4 px-4 py-2.5">
      <Icon
        name="heroicons/outline/exclamation-triangle"
        className="size-4.5 shrink-0"
      />
      <span className="typography-body-sm-bold text-center">
        You have no active price lists. Buyers can&apos;t see your products, so
        you won&apos;t receive any orders.
      </span>
      <Anchor
        href="/price-lists/"
        className="whitespace-nowrap"
        variant="inline-text"
        size="small"
      >
        Add a price list
        <ButtonIcon name="heroicons/solid/arrow-right" />
      </Anchor>
    </div>
  )
}
